import * as THREE from 'three';

// Wall thickness at angle theta (rad), smoothly interpolated from the 4 cardinal
// sides (right=0°, top=90°, left=180°, bottom=270°).
export function wallAt(thetaRad, sides) {
  const deg = ((thetaRad * 180) / Math.PI % 360 + 360) % 360;
  const pts = [
    [0, sides.right], [90, sides.top], [180, sides.left], [270, sides.bottom], [360, sides.right]
  ];
  let a = pts[0], b = pts[1];
  for (let i = 0; i < pts.length - 1; i++) {
    if (deg >= pts[i][0] && deg <= pts[i + 1][0]) { a = pts[i]; b = pts[i + 1]; break; }
  }
  const f = (deg - a[0]) / (b[0] - a[0] || 1);
  const s = f * f * (3 - 2 * f); // smoothstep
  return a[1] + (b[1] - a[1]) * s;
}

// A THREE.Shape: outer boundary with a variable wall over a circular inner hole.
export function annulusShape(innerR, sides, samples = 96) {
  const shape = new THREE.Shape();
  for (let i = 0; i <= samples; i++) {
    const t = (i / samples) * Math.PI * 2;
    const r = innerR + Math.max(0.01, wallAt(t, sides));
    const x = Math.cos(t) * r;
    const y = Math.sin(t) * r;
    if (i === 0) shape.moveTo(x, y);
    else shape.lineTo(x, y);
  }
  const hole = new THREE.Path();
  hole.absarc(0, 0, innerR, 0, Math.PI * 2, true);
  shape.holes.push(hole);
  return shape;
}

export const extrudeOpts = len => ({ depth: len, bevelEnabled: false, curveSegments: 48 });
